import { StyleSheet } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { filterBarRow } from '../../Constant/filterBarData';


const filterBarHeight = filterBarRow * 48 + 16 + 12;

export default StyleSheet.create({
    filterBarWrapper: {
        position: 'absolute',
        top: 1,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 3
    },
    filterBarModel: {
        flex: 1,
        backgroundColor: 'transparent'
    },
    animationView: {
        overflow: 'hidden'
    },
    filterBar: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        height: filterBarHeight,
        paddingTop: 16,
        paddingBottom: 12,
        paddingHorizontal: 14,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
    },
    filterBarItemWrapper: {
        alignItems: 'center',
        height: 48,
        paddingHorizontal: 6,
        paddingBottom: 12
    },
    filterBarItemInner: {
        width: '100%',
        height: 36,
        justifyContent: 'center',
        alignItems: 'center',
    },
    filterBarItemTitle: {
        fontSize: 14,
        textAlign: 'center',
    },
    filterBarItemTitleAvtived: {
        fontWeight: DeviceInfo.isIOS ? '600' : '400'
    }
});
